var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "form-info" },
    [
      _c(
        "el-form",
        { ref: "staffQualiTypeInfo", attrs: { model: _vm.checkItem } },
        [
          _c("div", { staticClass: "form-row" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", [_vm._v("参考标准")])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-value width-2x" }, [
              _c("span", [_vm._v(_vm._s(_vm.checkItem.standard))])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-row" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", [_vm._v("项目内容")])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-value width-2x" }, [
              _c("span", [_vm._v(_vm._s(_vm.checkItem.content))])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-row" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", [_vm._v("基本要求")])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-value width-2x" }, [
              _c("span", [_vm._v(_vm._s(_vm.checkItem.demand))])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-row" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", [_vm._v("适用分类")])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-value width-2x" }, [
              _c("span", [_vm._v(_vm._s(_vm.checkItem.appliedCatNames))])
            ])
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5048822e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5048822e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/rentServc/DevcMaintCheckItemDetail.vue
// module id = 1992
// module chunks = 1